import { z } from "zod";

export const conciliationSchema = z.object({
  divergences: z.array(z.object({
    id: z.number(),
    justification_id: z.number().optional(),
    operator: z.string().nullable().optional(),
    amount: z.number()
  })).refine((data) => {
    try {
      if (!data || data.length === 0) return true;

      const amounts = data.map(item => Number(item.amount) || 0);
      const hasPositive = amounts.some(amount => amount > 0);
      const hasNegative = amounts.some(amount => amount < 0);
      
      if ((hasPositive && !hasNegative) || (hasNegative && !hasPositive)) {
        return false;
      }

      const operators = data.map(item => {
        const operator = item.operator;
        return operator === null || operator === undefined || operator === "" ? "" : String(operator);
      });

      const uniqueOperators = Array.from(new Set(operators));
      const hasEmptyOperators = operators.some(op => !op);
      const hasDifferentOperators = uniqueOperators.length > 1 || hasEmptyOperators;

      const totalAmount = Math.abs(data.reduce((sum, item) => {
        const amount = typeof item.amount === 'number' && !isNaN(item.amount) ? item.amount : 0;
        return sum + amount;
      }, 0));

      if (hasDifferentOperators) {
        return data.every(item =>
          item.justification_id !== undefined &&
          item.justification_id !== null &&
          typeof item.justification_id === 'number'
        );
      }

      if (totalAmount > 5) {
        return data.every(item =>
          item.justification_id !== undefined &&
          item.justification_id !== null &&
          typeof item.justification_id === 'number'
        );
      }

      return true;
    } catch (error) {
      console.warn('Erro na validação de conciliação:', error);
      return true;
    }
  }, {
    message: "Para conciliar, selecione valores de sinais opostos (positivos e negativos). Justificativa obrigatória quando há operadores diferentes, vazios ou diferença superior a R$ 5,00"
  })
});

export type ConciliationSchema = z.infer<typeof conciliationSchema>;
